import axiosInstance from 'shared/api/axiosInstance';
import { endpoints } from 'shared/api/endPoints';

const unwrapRecords = (response) => {
  const payload = response?.data?.data;
  if (!payload || typeof payload !== 'object') {
    return { rows: [], totalRecords: 0 };
  }
  return {
    rows: Array.isArray(payload.data) ? payload.data : [],
    totalRecords: Number(payload.records ?? payload.totalRecords ?? payload.total ?? 0),
  };
};

export async function fetchUserAuditTrials({
  page = 0,
  size = 20,
  userId,
  outcome,
  activity,
  q,
} = {}) {
  const params = { page, size };
  if (userId) params.userId = userId;
  if (outcome) params.outcome = outcome;
  if (activity) params.activity = activity;
  if (q) params.q = q;
  const response = await axiosInstance.get(endpoints.userAuditTrials.list, { params });
  return unwrapRecords(response);
}

export async function fetchUserAuditTrial(id) {
  const response = await axiosInstance.get(
    `${endpoints.userAuditTrials.get}${encodeURIComponent(id)}`
  );
  return response?.data?.data ?? null;
}
